import { defineMessages } from 'react-intl';

export default defineMessages({
  completeStatusLink: {
    description: 'Batches Grid (All Statuses) > Batch Status - Complete Link (opens label batch status modal)',
    defaultMessage: 'Complete',
    id: 'pZYq9K',
  },
  errorsLinkText: {
    description: 'Batches > Processing Progress > # issues',
    defaultMessage: '{errors, plural, one {issue} other {issues}}',
    id: 'F2F30x',
  },
});
